import { createReducer, on, Action } from '@ngrx/store';
import { PlayerStatus } from '../player.model';

import * as fromPlayerActions from './player.actions';

export const playerFeatureKey = 'player';

export interface PlayerState {
  status: PlayerStatus;
  url: string;
  instances: number;
  message: string;
  PiP: boolean
}

export const initialState: PlayerState = {
  status: PlayerStatus.None,
  url: '',
  instances: 0,
  message: '',
  PiP: false
};

const playerReducer = createReducer(
  initialState,
  on(fromPlayerActions.PlayerReady, (state) => ({...state, status: PlayerStatus.Ready, message: '' })),
  on(fromPlayerActions.PlayRequest, (state, { url, PiP }) => ({ ...state, url, PiP, status: PlayerStatus.PlayRequest })),
  on(fromPlayerActions.PlayerPlaying, (state, { url, message }) => ({ ...state, url, message, status: PlayerStatus.Playing })),
  on(fromPlayerActions.StopRequest, (state) => ({...state, status: PlayerStatus.StopRequest })),
  on(fromPlayerActions.PlayerStopped, (state) => ({...state, status: PlayerStatus.Stopped })),
);

export function PlayerReducer(state: PlayerState | undefined, action: Action): PlayerState {
  return playerReducer(state, action);
}
